import { useContext } from "react";
import { IndexContext } from "../../context/IndexContext";

export function useShowNotification() {
  const { notificationApi } = useContext(IndexContext);

  const showNotification = ({ type = "error", message, description }) => {
    notificationApi[type]({
      message: message,
      description: description,
    });
  };

  return showNotification;
}
